'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _detectBrowser = require('detect-browser');

var _isUnsupportedBrowser = require('./util/isUnsupportedBrowser');

var _isUnsupportedBrowser2 = _interopRequireDefault(_isUnsupportedBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currentBrowser = (0, _detectBrowser.detect)();

function ExcludeBrowser(props) {
  var componentToRender = void 0;
  var UnsupportedBrowserMessage = props.unsupportedBrowserMessage;
  if (!(0, _isUnsupportedBrowser2.default)(currentBrowser, props.excludedBrowsers)) {
    componentToRender = props.children;
  } else {
    componentToRender = _react2.default.createElement(UnsupportedBrowserMessage, null);
  }
  return componentToRender;
}

exports.default = ExcludeBrowser;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-exclude-browser/build/ExcludeBrowser.js
// module id = 62
// module chunks = 0